import React from 'react';
import {useTranslation} from 'react-i18next';
import { motion } from 'framer-motion';
import { ASSETS_URL } from "../../constants";
import { fadeInLeft, fadeInRight, staggerContainer, staggerItem, cardHover } from '../../utility/framerMotionAnimations';

const TestimonialSection = () => {
    const {t}=useTranslation('homepage');
    return (
        <section className='testimonials-section mt-8 '>
            <div className="section-container flex-row mobile-flex-block">
                <motion.div 
                    className="col-md-40 mt-5 pm-40"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInLeft}
                >
                    <motion.div 
                        className="testimonials-title"
                        variants={fadeInLeft}
                    >
                        {t('testimonials-title.line1')} <br/>{t('testimonials-title.line2')}
                    </motion.div>
                    <motion.div 
                        className="testimonials-content mt-1"
                        variants={fadeInLeft}
                        transition={{ delay: 0.2 }}
                    >
                        {t('testimonials-content')}
                    </motion.div>
                </motion.div>
                <motion.div 
                    className="col-md-60 mt-5 m-mt-1 mob-testi-slider"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInRight}
                >
                    <motion.div 
                        className="testimonials-slider flex-row"
                        variants={staggerContainer}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    >
                        <motion.div 
                            className="testimonials-cards"
                            variants={staggerItem}
                            whileHover={cardHover.hover}
                        >
                            <div className="testimonials-text-star">
                                {/* <div className="testimonial-star">
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                </div> */}
                                <div className="testimonial-text">
                                {t('testimonial-text1')}
                                </div>
                                <div className="testimonials-profile mt-1 flex-row">
                                    {/* <div className="testimonial-profile-picture">
                                        <img src={`${ASSETS_URL}images/testimonial-profile.png`} alt="Profile"/>
                                    </div> */}
                                    <div className="testimonial-profile-name">
                                        <h1>{t('testimonial-profile-name1.line1')}</h1>
                                        <p>{t('testimonial-profile-name1.line2')}</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                        <motion.div 
                            className="testimonials-cards"
                            variants={staggerItem}
                            whileHover={cardHover.hover}
                        >
                            <div className="testimonials-text-star">
                                {/* <div className="testimonial-star">
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                    <img src={`${ASSETS_URL}images/star.svg`} alt="Star"/>
                                </div> */}
                                <div className="testimonial-text">
                                {t('testimonial-text2')}
                                </div>
                                <div className="testimonials-profile mt-1 flex-row">
                                    {/* <div className="testimonial-profile-picture">
                                        <img src={`${ASSETS_URL}images/testimonial-profile.png`} alt="Profile"/>
                                    </div> */}
                                    <div className="testimonial-profile-name">
                                        <h1>{t('testimonial-profile-name2.line1')}</h1>
                                        <p>{t('testimonial-profile-name2.line2')}</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
}

export default TestimonialSection;